import newBookNotification from '../common/new_book_notification.lib';
import loginHelper from '../common/account.loginHelper';
import toast from '../util/toast';
import { newBookNotification as eventNewBookNotification } from '../util/eventClient';

$(() => {
  const $controlBar = $('.js_control_bar');
  const $fixedArea = $('.js_fixed_area');
  if ($controlBar.length > 0) {
    $(window).scroll(() => {
      const scrollTopNow = $(window).scrollTop();
      if (scrollTopNow > $controlBar.offset().top) {
        $fixedArea.addClass('fixed');
      } else {
        $fixedArea.removeClass('fixed');
      }
    });
  }
});


const TARGET_TYPE_AUTHOR = 'author';
const TARGET_TYPE_SERIES = 'series';
const UNREGISTER_COMPLETE_BOOK_IDS = 0;

const getCsrfToken = () => $('#notification_csrf_token').val() || '';
// ajax 오류일 경우 처리
function ajaxFailureCallback(jqXhr, response) {
  // not authorized
  if (jqXhr.status === 401) {
    toast.fail('로그인 후 다시 시도해주세요.');
    return false;
  }

  if (jqXhr.responseJSON !== undefined) {
    toast.fail(jqXhr.responseJSON.message);
    return false;
  }

  // DB 또는 runtime error
  if (response === undefined) {
    toast.fail('처리 도중 오류가 발생했습니다. 잠시 후 다시 시도해주세요.');
    return false;
  }

  return true;
}

function addSpinner(target) {
  target.addRuiSpinner();
}

function removeSpinner(target) {
  target.removeRuiSpinner();
}

function changeNotificationStatus(target) {
  if (target.hasClass('delete_button')) { // 작가/시리즈 탭에서 삭제시
    target.parents('li').hide();
    return false;
  }

  const id = target.data('id'); // author_id or series_id
  const type = (target.hasClass('js_author_noti')) ? TARGET_TYPE_AUTHOR : TARGET_TYPE_SERIES;
  let action;
  let notAction;

  if (target.hasClass(`js_${type}_noti_register`)) { // 등록인지 삭제인지 확인
    action = 'register';
    notAction = 'unregister';
  } else {
    action = 'unregister';
    notAction = 'register';
  }

  // 신간알림 등록/취소할 작가/시리즈의 id값이 같은 것들의 버튼들도 같이 바꿔준다.
  const duplicateIdTypeActionSelector = `.js_${type}_noti_${action}[data-id="${id}"]`;
  $(duplicateIdTypeActionSelector).each(function () {
    $(this).addClass('hidden');
  });

  const duplicateIdTypeNotActionSelector = `.js_${type}_noti_${notAction}[data-id="${id}"]`;
  $(duplicateIdTypeNotActionSelector).each(function () {
    $(this).removeClass('hidden');
  });

  return false;
}

function getSelectedOrderOption() {
  const $regDate = $('.js_new_release_order_option:eq(0)');
  return $regDate.hasClass('active') ? 'reg_date' : 'name';
}

export function bindSeriesNewBookNotiEvents() {
  $('.js_new_release_order_option').click(function () {
    const type = $(this).hasClass('js_author_select') ? TARGET_TYPE_AUTHOR : TARGET_TYPE_SERIES;
    newBookNotification.notificationOrder(type, $(this).attr('value'));
  });

  $('.js_series_noti_register').click(function () {
    if (!loginHelper.isLoggedIn) {
      loginHelper.showLogin();
      return false;
    }

    const targetId = $(this).data('id');
    const targetType = TARGET_TYPE_SERIES;
    const $this = $(this);

    addSpinner($this);
    newBookNotification.register(targetId, targetType, getCsrfToken(), response => {
      changeNotificationStatus($this);
      eventNewBookNotification(true);

      toast.success({
        text: response.message,
        linkUrl: response.modify_link,
        linkTitle: '목록 보기',
      });
    }, (jqXhr, response) => {
      ajaxFailureCallback(jqXhr, response);
    }, () => {
      removeSpinner($this);
    });

    return true;
  });

  $('.js_series_noti_unregister').click(function () {
    if (!loginHelper.isLoggedIn) {
      loginHelper.showLogin();
      return false;
    }

    const targetId = $(this).data('id');
    const targetType = TARGET_TYPE_SERIES;
    const option = 'default';
    const order = getSelectedOrderOption();
    const $this = $(this);

    addSpinner($this);
    newBookNotification.unregister(targetId, targetType, option, order, getCsrfToken(), response => {
      changeNotificationStatus($this);
      eventNewBookNotification(false);

      if ($this.hasClass('delete_button')) {
        toast.success({
          text: response.message,
          linkUrl: `${response.withdraw_link}&_token=${getCsrfToken()}`,
          linkTitle: '삭제 취소',
        });
      } else {
        toast.success(response.message);
      }
    }, (jqXhr, response) => {
      ajaxFailureCallback(jqXhr, response);
    }, () => {
      removeSpinner($this);
    });

    return true;
  });

  $('.js_delete_complete').click(function () {
    const targetType = TARGET_TYPE_SERIES;
    const option = 'complete';
    const order = getSelectedOrderOption();
    const $this = $(this);

    addSpinner($this);
    newBookNotification.unregister(UNREGISTER_COMPLETE_BOOK_IDS, targetType, option, order, getCsrfToken(), response => {
      toast.success(response.message);

      setTimeout(() => {
        window.location.replace(window.location.href.split('&')[0]);
      }, 2000);
    }, (jqXhr, response) => {
      ajaxFailureCallback(jqXhr, response);
    }, () => {
      removeSpinner($this);
    });
  });
}

export function bindAuthorNewBookNotiEvents() {
  $('.js_author_noti_register').click(function () {
    if (!loginHelper.isLoggedIn) {
      loginHelper.showLogin();
      return false;
    }

    const targetId = $(this).data('id');
    const targetType = TARGET_TYPE_AUTHOR;
    const $this = $(this);

    addSpinner($this);
    newBookNotification.register(targetId, targetType, getCsrfToken(), response => {
      changeNotificationStatus($this);
      toast.success({
        text: response.message,
        linkUrl: response.modify_link,
        linkTitle: '목록 보기',
      });
    }, (jqXhr, response) => {
      ajaxFailureCallback(jqXhr, response);
    }, () => {
      removeSpinner($this);
    });

    return true;
  });

  $('.js_author_noti_unregister').click(function () {
    if (!loginHelper.isLoggedIn) {
      loginHelper.showLogin();
      return false;
    }

    const targetId = $(this).data('id');
    const targetType = TARGET_TYPE_AUTHOR;
    const option = 'default';
    const order = getSelectedOrderOption();
    const $this = $(this);

    addSpinner($this);
    newBookNotification.unregister(targetId, targetType, option, order, getCsrfToken(), response => {
      changeNotificationStatus($this);

      if ($this.hasClass('delete_button')) {
        toast.success({
          text: response.message,
          linkUrl: `${response.withdraw_link}&_token=${getCsrfToken()}`,
          linkTitle: '삭제 취소',
        });
      } else {
        toast.success(response.message);
      }
    }, (jqXhr, response) => {
      ajaxFailureCallback(jqXhr, response);
    }, () => {
      removeSpinner($this);
    });

    return true;
  });
}

export function bindNewBookVerifyEvents() {
  $('.js_noti_setup_button').click(function () {
    const $this = $(this);
    const thisActive = $this.hasClass('active');

    let isAlarmCenter = $('.js_alarm_center').hasClass('active');
    let isEmail = $('.js_email').hasClass('active');
    let isPush = $('.js_push').hasClass('active');

    if ($this.hasClass('js_alarm_center')) {
      isAlarmCenter = !isAlarmCenter;
    } else if ($this.hasClass('js_email')) {
      isEmail = !isEmail;
    } else if ($this.hasClass('js_push')) {
      isPush = !isPush;
    }

    addSpinner($this);

    newBookNotification.changeAlarm(isAlarmCenter, isEmail, isPush, getCsrfToken(), response => {
      if (response.result === 'NO_EMAIL') {
        if (window.confirm('신간알림을 받기 위해서 이메일 정보가 필요합니다. 이메일 주소를 등록하시겠습니까?')) {
          window.location = response.url;
        } else {
          window.location.reload();
        }
        return;
      }

      if (thisActive) {
        $this.removeClass('active');
      } else {
        $this.addClass('active');
      }

      toast.success(response.message);
    }, (jqXhr, response) => {
      ajaxFailureCallback(jqXhr, response);
    }, () => {
      removeSpinner($this);
    });
  });

  $('.js_reopen_notification').click(function () {
    const $this = $(this);

    addSpinner($this);
    if (!loginHelper.isLoggedIn) {
      loginHelper.showLogin();
      return false;
    }

    newBookNotification.reopenNotification($this.data('id'), getCsrfToken(), response => {
      toast.fail(response.message);
      window.location = response.url;
    }, (jqXhr, response) => {
      ajaxFailureCallback(jqXhr, response);
    }, () => {
      removeSpinner($this);
    });

    return true;
  });
}

$(() => {
  bindSeriesNewBookNotiEvents();
  bindAuthorNewBookNotiEvents();
  bindNewBookVerifyEvents();
});



// WEBPACK FOOTER //
// ./my_ridi/new_book_notification.js